const translation = {
  custom: 'سفارشی سازی',
  upgradeTip: {
    prefix: 'طرح خود را ارتقا دهید به',
    suffix: 'تا برند خود را سفارشی کنید.',
    title: 'طرح خود را ارتقا دهید',
    des: 'طرح خود را ارتقا دهید تا برند خود را سفارشی کنید',
  },
  webapp: {
    title: 'سفارشی سازی برند وب اپ',
    removeBrand: 'حذف "Powered by Dify"',
    changeLogo: 'تغییر تصویر برند "Powered by"',
    changeLogoTip: 'فرمت SVG یا PNG با حداقل اندازه 40x40px',
  },
  app: {
    title: 'سفارشی سازی برند هدر اپلیکیشن',
    changeLogoTip: 'فرمت SVG یا PNG با حداقل اندازه 80x80px',
  },
  upload: 'بارگذاری',
  uploading: 'در حال بارگذاری',
  uploadedFail: 'بارگذاری تصویر ناموفق بود، لطفاً دوباره بارگذاری کنید.',
  change: 'تغییر',
  apply: 'اعمال',
  restore: 'بازگرداندن به پیشفرضها',
  customize: {
    contactUs: ' با ما تماس بگیرید ',
    prefix: 'برای سفارشیسازی لوگوی برند در اپلیکیشن، لطفاً',
    suffix: 'برای ارتقا به نسخه Enterprise.',
  },
}

export default translation
